define([
  "jquery",
  "knockout"],
function($, ko) {

  "use strict";

  ko.bindingHandlers.selectElementContent = {

    init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

      $(element).click(function() {
        var doc = document;
        var range;
        var selection;
        if (doc.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(element);
          range.select();
        } else if (window.getSelection) {
          selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(element);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });

    }
  };

});
